export default "__VITE_ASSET__DRJaReNF__"